import React, { Component, createRef } from 'react';
import Axios from 'axios';
import { 
	DURATION_TYPE,
	INFORMED_BY,
	MEDICATION_ON,
	FETAL_MOVEMENT,
	PRESENTATION,
	RELATIONSHIP_TO_PP_BRIM,
	CONCEPTION_OPTIONS,
    PREGNANCY_OPTIONS,
    DELIVERY_OPTIONS,
    OUTCOME_OPTIONS,
    PLACE_OF_DELIVERY_OPTIONS,
    LOADER,
    Print_Anc_Details
 } from "../../utils/constant";
import moment from "moment";
import { DatePicker, Radio, Modal, Select, Button, Form, Checkbox, Input, Tooltip, AutoComplete, notification } from 'antd';
import AsideLeft from '../../components/aside/asideleft';
import LS_SERVICE from "../../utils/localStorage";

export default class AncCardView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            patientInfo: props.patientInfo || [],
            risk_factors_options: props.riskFactorsOptions || [],
            indexKey: props.index,
            AncCardData : props.AncCardData,
            gender_options: [
                { val: '1', label: 'Male' },
                { val: '2', label: 'Female' },
                { val: '3', label: 'Transgender' }
            ],
            showRxModal: false,
    		rxPdfPath: null,
    		isPrintLoader: false,
        }
    }

    getPatientAge(dob) {
        var ageD = Math.floor(moment().diff(moment(dob, 'YYYY-MM-DD'), 'D') / (1000 * 3600 * 24));
        var ageM = moment().diff(moment(dob, 'YYYY-MM-DD'), 'M');
        var ageY = ageM / 12;
        var remainM = ageM % 12;
        ageY = Math.floor(ageY);
        var ageText = '';
        if (ageM == 0)
            ageText = ageD + ' Day' + (ageD == 1 ? '' : 's');
        else if (ageY < 1)
            ageText = ageM + ' Mon' + (ageM == 1 ? '' : 's');
        else if (ageY <= 5) {
            if (remainM != 0) {
                ageText = ageY + ' Yr' + (ageY == 1 ? '' : 's ') + remainM + ' Mon' + (remainM == 1 ? '' : 's');
            } else {
                ageText = ageY + ' Yr' + (ageY == 1 ? '' : 's');
            }
        }
        else
        ageText = ageY + ' Years' + (remainM != 0 ? ' ' + remainM + ' Month' + (remainM === 1 ? '' : 's') : '');
        return ageText;
    }

    getListValue(selectedValue, OptionObj = null) {
        if (selectedValue == 0 || selectedValue === null) {
            return "-";
        } else if (OptionObj) {
            return OptionObj[selectedValue];
        } else {
            return selectedValue;
        }
    }

    showPhysicalExamFPData(mother_fetus_data, mother_parameter_data) {
        if (mother_fetus_data.length == 0) {
            return (
                <tr>
                    <td colSpan="6">No data available</td>
                </tr>
            );
        }
        return mother_fetus_data.map((data, i) => (
            <tr key={data.id} className={i != 0 ? 'highlight_bg' : ''}>
                <td className="text-center" style={(i + 1) == mother_fetus_data.length && (i + 1) == mother_fetus_data.length ? { paddingBottom: '20px' } : {}}>{i + 1}</td>
                <td className="text-center">{this?.getListValue(data.fetal_movement, FETAL_MOVEMENT)}</td>
                <td className="text-center">{data.fetal_heart_rate || '-'}</td>
                <td className="text-center">{this?.getListValue(data.presentation, PRESENTATION)}</td>
                <td className="text-center">{this?.getListValue(data.relationship_of_pp_to_brim, RELATIONSHIP_TO_PP_BRIM)}</td>
                <td className="text-center">{data.head_cc || '-'}</td>
                <td className="text-center">{data.abdominal_cc || '-'}</td>
                <td className="text-center">{data.femur_length || '-'}</td>
                {
                	i == 0 
                	?
	                    <td rowSpan={mother_fetus_data.length}>
	                    	{mother_parameter_data?.mother_remarks || '-'}
	            		</td>
                    : 
                    null
                }
            </tr>
        ));
    }

    printAncDetails = async () => {
    	const { AncCardData } = this.state;
	    const BODY = {
	    	patient_id: parseInt(AncCardData.patient_id),
			reference_id: parseInt(AncCardData.reference_id),
			reference_type: parseInt(AncCardData.reference_type),
			hospital_id: parseInt(AncCardData.hospital_id),
			enterprise_id: parseInt(AncCardData.enterprise_id),
			source: AncCardData.source,
	    }
	    await this.setState({ isPrintLoader : true });
	    await Axios.post(Print_Anc_Details, BODY).then(async (response) => {
			if(response.data.status == true)
			{
				await this.setState({ rxPdfPath: response.data.pdf_url, showRxModal: true, });

			} else {
				notification.error({
	                message: "Oops! Something snapped. Please try again.",
	                placement: "topRight",
	            });
			}
	    	await this.setState({ isPrintLoader : false });
	    }).catch(async (err) => {
			notification.error({
                message: "Oops! Something snapped. Please try again.",
                placement: "topRight",
            });
            await this.setState({ isPrintLoader : false });
	    });
    
  	}

    showMultiplePregnancyData(multiple_pregnancies) {
    	if (multiple_pregnancies.length == 0) {
            return (
                <tr>
                    <td colSpan="10">No data available</td>
                </tr>
            );
        }
        return multiple_pregnancies.map((data, i) => (
            <tr key={data.id} className={i != 0 ? 'highlight_bg' : ''}>
                <td className="text-center" style={(i + 1) == multiple_pregnancies.length && (i + 1) == multiple_pregnancies.length ? { paddingBottom: '20px' } : {}}>{i + 1}</td>
                <td className="text-center">{DELIVERY_OPTIONS?.filter(x => x.val == data.delivery_type)?.[0]?.label}</td>
                <td className="text-center">{PLACE_OF_DELIVERY_OPTIONS?.filter(x => x.val == data.delivery_place)?.[0]?.label}</td>
                <td className="text-center">{OUTCOME_OPTIONS?.filter(x => x.val == data.delivery_outcome)?.[0]?.label}</td>
                <td className="text-center">{this.state.gender_options?.filter(x => x.val == data.delivery_gender)?.[0]?.label}</td>
                <td className="text-center">{ data?.delivery_bith_date_time != null ? moment(data?.delivery_bith_date_time).format("DD MMM, YYYY | hh:mm A") : 'N/A'}</td>
                <td className="text-center">{data.delivery_birth_weight}</td>
                <td className="text-center">{data.delivery_birth_height}</td>
                <td className="text-center">{data.delivery_birth_head_cc}</td>
                <td className="text-center">{data?.delivery_congenital_abnormality == "true" ? "Yes" : "No"}</td>
                <td className="text-center">{data.delivery_congenital_abnormality_remarks}</td>
            </tr>
        ));
    }

    render() {
        const { patientInfo, risk_factors_options, AncCardData } = this.state;
        return (
            <>
                <div className='mt-2 anc_accordion' id={"accordion" + this.state.indexKey}>
                    <div className="card">
                        <div className="card-header" id={"headingOne" + this.state.indexKey}>
                            <button className="btn btn-block text-left  collapsed arrow float-right anc_button mb-0" data-toggle="collapse" data-target={"#collapseOne" + this.state.indexKey} aria-expanded="true" aria-controls={"collapseOne" + this.state.indexKey}>
                                <div className='row'>
                                    <div className='col-3'>
                                        <span className='title'>ANC Card Details</span>
                                    </div>
                                    <div className='col-4'>
                                        <span className='title'>Delivery Date :&nbsp;</span>
                                        <span className='title'>{AncCardData.delivery_date != null ? moment(AncCardData.delivery_date).format("D MMM, YYYY") : null}</span>
                                    </div>
                                    <div className='col-4'>
                                        <span className='title'>Last Update :&nbsp;</span>
                                        <span className='title'>{AncCardData.updatedAt ? moment(AncCardData.updatedAt).format("D MMM, YYYY ") : null}</span>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div id={"collapseOne" + this.state.indexKey} className="collapse " aria-labelledby={"headingOne" + this.state.indexKey} data-parent={"#accordion" + this.state.indexKey}>
                            <div className="card-body px-0"></div>

                            <div className="container-fluid emrfrm anc-container mb-4 ">
                                <Form
                                    layout="vertical"
                                    className="emrfrm"
                                >
                                	{
                                		(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != null) || (AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != null)
                                		?
	                                		<>
			                                	<div className='row mt-4'>
			                                        {
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != null) 
			                                        	?
				                                            <div className='col-6' >
				                                                <span style={{ color: "#FF0000" }}>Risk Factors</span>
				                                            </div>
			                                            : 
			                                            null
			                                        }
			                                        {
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != null) 
			                                        	?
			                                            <div className='col-6'>
			                                                <span style={{ color: "#FF0000" }}>Risk Factors Management Remarks</span>
			                                            </div>
			                                            : 
			                                            null
			                                        }
			                                    </div>
			                                    <div className='row '>
			                                    	{
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name != null) 
			                                        	?
			                                        		<>
					                                        <div className='col-6'>
					                                            <span><pre style={{ fontSize: "15px", border: "none" }}>{AncCardData?.obs_gyane_data?.pregnancy_risk_factor_name}</pre></span>
					                                        </div>
					                                        </>
					                                    :
					                                    null
					                                }

					                                {
			                                        	(AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != "" && AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks != null) 
			                                        	?
			                                        		<>
					                                        <div className='col-6'>
					                                            <span><pre style={{ fontSize: "15px", border: "none" }}>{AncCardData?.obs_gyane_data?.pregnancy_risk_factor_management_remarks.replace(/\n/g, '<br>')}</pre></span>
					                                        </div>
					                                        </>
					                                    :
					                                    null
					                                }
			                                    </div>
		                                    </>
		                                :
		                                null
	                                }

	                                {
	                                	AncCardData?.current_allergies?.length > 0 
	                                	? 
	                                		<>
		                                        <div className='row mt-4'>
		                                            <div className='col-12'>
		                                                <span className='title'> Allergies</span>
		                                            </div>
		                                        </div>

		                                        <table className="table table-bordered mt-3" >
		                                            <thead>
		                                                <tr>
		                                                    <td width="28%">ALLERGY NAME</td>
		                                                    <td width="22%">REACTION</td>
		                                                    <td width="15%">DURATION</td>
		                                                    <td width="15%">INTENSITY</td>
		                                                    <td width="15%">INFORMED BY</td>
		                                                </tr>
		                                            </thead>
		                                            <tbody>
		                                                {AncCardData?.current_allergies.map(obj => {
		                                                    return (
		                                                        <tr>
		                                                            <td>{(obj.allergy_name) ? obj.allergy_name : '-'}</td>
		                                                            <td>{(obj.reaction) ? obj.reaction : '-'}</td>
		                                                            <td>{obj.duration ? obj.duration + ' ' + DURATION_TYPE[obj.durationType] : '-'}</td>
		                                                            <td>{obj.intensity === 0 ? "Low" : obj.intensity === 1 ? "Medium" : obj.intensity === 2 ? "High" : ''}</td>
		                                                            <td>{obj.informedBy ? INFORMED_BY[obj.informedBy] : '-'}</td>
		                                                        </tr>
		                                                    )
		                                                })
		                                                }
		                                            </tbody>
		                                        </table>
                                    		</> 
                                		: 
                                		null
                                	}
                                	{
                                		AncCardData?.current_conditions?.length > 0 
                                		? 
                                			<>
		                                        <div className='row mt-4'>
		                                            <div className='col-12'>
		                                                <span className='title'>Existing Condition</span>
		                                            </div>
		                                        </div>

		                                        <table className="table table-bordered mt-3" >
		                                            <thead>
		                                                <tr>
		                                                    <td width="30%">CONDITIONS</td>
		                                                    <td width="20%">DURATION</td>
		                                                    <td width="20%">ON MEDICATION</td>
		                                                    <td width="30%">MEDICINE NAME</td>
		                                                </tr>
		                                            </thead>
		                                            <tbody>
		                                                {AncCardData?.current_conditions.map(obj => {
		                                                    return (
		                                                        <tr>
		                                                            <td>{obj.condition_description}</td>
		                                                            <td>{(obj.duration) ? `${obj.duration} ${DURATION_TYPE[obj.durationType]}` : '-'}</td>
		                                                            <td>{MEDICATION_ON[obj.onMedication] ? MEDICATION_ON[obj.onMedication] : '-'}</td>
		                                                            <td>{obj.medicineName || "NA"}</td>
		                                                        </tr>
		                                                    );
		                                                })
		                                                }
		                                            </tbody>
		                                        </table>
                                    		</>
                                		: 
                                		null
                                	}
                                	{
                                    	AncCardData?.menstural_data 
                                    	?
	                                        <>
	                                            <div className='row mt-4'>
	                                                <div className='col-3'>
	                                                    <span className='title'>Menstrual Hx</span>
	                                                </div>
	                                                <div className='col-2'>
	                                                    <span>LMP:</span>
	                                                    <span className='title'>
	                                                    	{(AncCardData?.menstural_data?.lmp && AncCardData?.menstural_data.lmp != null) ? moment(AncCardData?.menstural_data.lmp).format('YYYY-MM-DD'): '-'}
                                                    	</span>
	                                                </div>
	                                                <div className='col-2'>
	                                                    {
	                                                    	(AncCardData?.menstural_data?.cycle_length != null && AncCardData?.menstural_data?.cycle_length != "")
	                                                    	?
		                                                        <>
		                                                            <span>Cycle Length:</span>
		                                                            <span className='title'>
		                                                            	{AncCardData?.menstural_data?.cycle_length + " days"}
	                                                            	</span>
		                                                        </>
	                                                        : 
	                                                        null
	                                                    }
	                                                </div>
	                                                <div className='col-5 text-right'>
	                                                    <span className='title'>Last Updated
                                                        ({moment(AncCardData?.menstural_data?.updatedAt).format("D MMM, YYYY | h:mm A")}
                                                        )</span>
	                                                </div>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	AncCardData ?
                                        <>
                                            <div className='row mt-4 d-flex align-items-center'>
                                                <div className='col-2'>
                                                    <span className='title'>Obstetric Hx</span>
                                                </div>
                                                {AncCardData?.obs_gyane_data?.edd_by_lmp ?
                                                    <div className='col-3'>
                                                        <span>EDD by LMP:</span><span className='title'> {AncCardData?.obs_gyane_data?.edd_by_lmp ? moment(AncCardData?.obs_gyane_data?.edd_by_lmp).format("D MMM, YYYY") : '-'}</span>
                                                    </div>
                                                    : null}
                                                {AncCardData?.obs_gyane_data?.corrected_edd != null && AncCardData?.obs_gyane_data?.corrected_edd != "" && AncCardData?.obs_gyane_data?.corrected_edd != undefined ?
                                                    <div className='col-auto'>
                                                        <div className='card obs_card'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <span className='title_red'>Corrected EDD:</span><span >{moment(AncCardData?.obs_gyane_data?.corrected_edd).format("D MMM, YYYY")}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null
                                                }
                                                {
                                                	AncCardData?.obs_gyane_data?.lactating && AncCardData?.obs_gyane_data?.lactating == "1"
                                                	?
	                                                    <div className='col-2 text-right'>
	                                                        <span className='title'>Lactating</span>
	                                                    </div>
                                                    : 
                                                    null
                                                }
                                                {
                                                	AncCardData?.obstetric_data 
                                                	?
	                                                    <div className='col-2 text-right'>
	                                                        <span className='title'>
	                                                        	<span className="bg-grey  py-1 px-3 rounded font-weight-bold">
														            {(AncCardData?.obstetric_data.gravidity != null && AncCardData?.obstetric_data.gravidity !== '') ? 'G'+AncCardData?.obstetric_data.gravidity+' ' : ''}{(AncCardData?.obstetric_data.parity != null && AncCardData?.obstetric_data.parity !== '') ? 'P'+AncCardData?.obstetric_data.parity+' ' : ''}{(AncCardData?.obstetric_data.abortion != null && AncCardData?.obstetric_data.abortion !== '') ? 'A'+AncCardData?.obstetric_data.abortion+' ' : ''}{(AncCardData?.obstetric_data.live_birth != null && AncCardData?.obstetric_data.live_birth !== '') ? 'L'+AncCardData?.obstetric_data.live_birth+' ' : ''}{(AncCardData?.obstetric_data.ectopic != null && AncCardData?.obstetric_data.ectopic !== '') ? 'E'+AncCardData?.obstetric_data.ectopic+' ' : ''}
													          	</span>
	                                                        </span>
	                                                    </div>
                                                    : 
                                                    null
                                                }
                                            </div>
                                            {
                                            	AncCardData?.obs_gyane_data?.obstetric_remarks && AncCardData?.obs_gyane_data?.obstetric_remarks != "" && AncCardData?.obs_gyane_data?.obstetric_remarks != null 
                                            	?
		                                            <div className='row mt-4'>
		                                                <div className='col-2'>
		                                                    <span className='title'>Obstetric Remarks</span>
		                                                </div>
		                                                <div className='col-10'>
		                                                    <pre style={{ fontSize: "15px", border: "none" }}>{AncCardData?.obs_gyane_data.obstetric_remarks.replace(/\n/g, '<br>')}</pre> 
		                                                </div>
		                                            </div>
                                            	: 
                                            	null
                                            }
                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	AncCardData.mother_parameter_data || (AncCardData.mother_fetus_data && AncCardData.mother_fetus_data.length > 0) 
                                    	?
	                                        <>
	                                            <div className='row mt-4'>
	                                                <div className='col-12'>
	                                                    <span className='title'> Physical Examination</span>
	                                                </div>
	                                            </div>
	                                            {
	                                            	AncCardData.mother_parameter_data ?
	                                                <>
	                                                    <div className='row mt-3 '>
	                                                        <div className='col-4'>
	                                                            <span className='title'>Mother's Parameters</span>
	                                                        </div>
	                                                        <div className='col-8 text-right'>
	                                                            <span className='title'>
	                                                            	Last Updated ({moment(AncCardData.mother_parameter_data.updatedAt).format("D MMM, YYYY | h:mm A")})
	                                                            </span>
	                                                        </div>
	                                                        <table className="table table-bordered mt-3" >
	                                                            <thead>
	                                                                <tr>
	                                                                    <td width="10%">POG (WEEKS)</td>
	                                                                    <td width="10%">WEIGHT (KG)</td>
	                                                                    <td width="10%">BP (MMHG)</td>
	                                                                    <td width="10%">PULSE RATE (MIN)</td>
	                                                                    <td width="10%">FUNDAL HT (CM)</td>
	                                                                    <td width="10%">EDEMA</td>
	                                                                    <td width="10%">PALLOR</td>
	                                                                    <td width="10%">CERVIX EXAM</td>
	                                                                    <td width="10%">PRETERM LABOUR (SIGN/SYMPTOMS)</td>
	                                                                </tr>
	                                                            </thead>
	                                                            <tbody>
	                                                            	<tr>
													                    <td>{AncCardData.mother_parameter_data.pog || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.weight || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.blood_pressure || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.pulse_rate || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.fundal_height || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.edema || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.pallor || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.cervix_exam || '-'}</td>
													                    <td>{AncCardData.mother_parameter_data.preterm_labour || '-'}</td>
													                </tr>
	                                                            </tbody>
	                                                        </table>
	                                                    </div>
	                                                </>
	                                                : 
	                                                null
	                                            }
	                                            <div className='row mt-4 '>
	                                                <div className='col-4'>
	                                                    <span className='title'>Fetal Parameters</span>
	                                                </div>
	                                                {
	                                                	(AncCardData.mother_fetus_data && AncCardData.mother_fetus_data.length > 0) 
	                                                	?
		                                                    <div className='col-8 text-right'>
		                                                        <span className='title'>Last Updated
		                                                            ({AncCardData.mother_fetus_data?.map((data, index) => (index == 0 ? moment(data.createdAt).format("D MMM, YYYY | h:mm A") : ''))})
		                                                        </span>
		                                                    </div>
	                                                    : null
	                                                }
	                                                <table className="table table-bordered mt-3" >
	                                                    <thead>
	                                                        <tr>
	                                                            <td width="10%">PARAMETERS</td>
	                                                            <td width="10%">FETUS NO.</td>
	                                                            <td width="10%">FETAL MOVEMENT</td>
	                                                            <td width="10%">FHR(B/Min)</td>
	                                                            <td width="10%">PRESENTATION</td>
	                                                            <td width="10%">RELATION OF PP TO BRIM</td>
	                                                            <td width="10%">HEAD CC (CM)</td>
	                                                            <td width="10%">ABDOMINAL CC (CM)</td>
	                                                            <td width="10%">FEMUR LENGTH(CM)</td>
	                                                            <td width="10%">REMARKS</td>
	                                                        </tr>
	                                                    </thead>
	                                                    <tbody>
	                                                        {this.showPhysicalExamFPData(AncCardData?.mother_fetus_data, AncCardData?.mother_parameter_data)}
	                                                    </tbody>
	                                                </table>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }

                                    {
                                    	AncCardData?.vaccine_data?.length > 0 
                                    	? 
                                    		<>
		                                        <div className='row mt-4 '>
		                                            <div className='col-12'>
		                                                <span className='title'>Immunoprophylaxis</span>
		                                            </div>
		                                        </div>

		                                        <div className='row mt-3'>
		                                            {
		                                                AncCardData.vaccine_data.map((obj) => {
		                                                    return (
		                                                        <div className='col-3'>
		                                                            <span>{obj.name}</span>
		                                                            <b>: {obj.vaccine_date != null ? moment(obj.vaccine_date).format('DD MMM, YYYY') : 'N/A'}</b>
		                                                        </div>
		                                                    )
		                                                })
		                                            }
		                                        </div>
                                    		</> 
                                		: 
                                		null
                                	}

                                    {
                                    	AncCardData?.immuno_remarks
                                    	?
	                                        <div className='row mt-2'>
	                                            <div className='col-12'>
	                                                <span className='title'>Immunoprophylaxis Remarks</span>
	                                                <b><pre style={{ fontSize: "15px", border: "none" }}> {AncCardData?.immuno_remarks}</pre></b>
	                                            </div>
	                                        </div>
                                        : 
                                        null
                                    }
                                    <div className='row mt-4 '>
                                        <div className='col-12'>
                                            <span className='title'>Delivery Details</span>
                                        </div>
                                    </div>

                                    <div className='row mt-3'>
                                    	<div className='col-4'>
                                            <span>Year:</span>
                                            <b> {AncCardData?.pregnancy_year}</b>
                                        </div>
                                        <div className='col-4'>
                                            <span>Mode:</span>
                                            <b> {AncCardData?.delivery_mode === "1" ? "Natural" : AncCardData?.delivery_mode === "2" ? "IVF" : AncCardData?.delivery_mode === "3" ? "IUI" : ''}</b>
                                        </div>
                                        <div className='col-4'>
                                            <span>Pregnancy Type:</span>
                                            <b> {AncCardData?.pregnancy_type == "1" ? "Single" :
                                                AncCardData?.pregnancy_type == "2" ? "Multiple" :
                                                    AncCardData?.pregnancy_type == "3" ? "Ectopic" : ''}</b>
                                        </div>
                                    </div>

                                    {
                                    	AncCardData?.pregnancy_type != "2"
                                    	?
                                    		<div className='row mt-3'>
	                                        	<div className='col-12'>
                                                    <span className='title'>Pregnancy Details</span>
                                                </div>
	                                            <div className='col-12'>
	                                                <table className="table table-bordered mt-3" >
	                                                    <thead>
	                                                        <tr>
	                                                            <td width="10%">Delivery Type</td>
	                                                            <td width="10%">Delivery Place</td>
	                                                            <td width="10%">Outcome</td>
	                                                            <td width="5%">Gender</td>
	                                                            <td width="10%">Birth Date & Time</td>
	                                                            <td width="10%">Birth Weight (kg)</td>
	                                                            <td width="10%">Birth Height (cm)</td>
	                                                            <td width="10%">Birth Head CC (cm)</td>
	                                                            <td width="10%">Congenital Abnormality</td>
	                                                            <td width="10%">Congenital Abnormality Remarks</td>
	                                                        </tr>
	                                                    </thead>
	                                                    <tbody>
	                                                    	<tr>
												                <td className="text-center">{DELIVERY_OPTIONS?.filter(x => x.val == AncCardData.delivery_type)?.[0]?.label}</td>
												                <td className="text-center">{PLACE_OF_DELIVERY_OPTIONS?.filter(x => x.val == AncCardData.delivery_place)?.[0]?.label}</td>
												                <td className="text-center">{OUTCOME_OPTIONS?.filter(x => x.val == AncCardData.delivery_outcome)?.[0]?.label}</td>
												                <td className="text-center">{this.state.gender_options?.filter(x => x.val == AncCardData.delivery_gender)?.[0]?.label}</td>
												                <td className="text-center">{ AncCardData?.delivery_bith_date_time != null ? moment(AncCardData?.delivery_bith_date_time).format("DD MMM, YYYY | hh:mm A") : 'N/A'}</td>
												                <td className="text-center">{AncCardData.delivery_birth_weight}</td>
												                <td className="text-center">{AncCardData.delivery_birth_height}</td>
												                <td className="text-center">{AncCardData.delivery_birth_head_cc}</td>
												                <td className="text-center">{AncCardData?.delivery_congenital_abnormality == "true" ? "Yes" : "No"}</td>
												                <td className="text-center">{AncCardData.delivery_congenital_abnormality_remarks}</td>
											            	</tr>
	                                                    </tbody>
	                                                </table>
	                                            </div>
	                                        </div>
	                                    :
	                                    null
	                                }

                                    {
                                    	AncCardData?.pregnancy_type == "2" && AncCardData.multiple_pregnancies.length > 0 
                                    	?
	                                        <div className='row mt-3'>
	                                        	<div className='col-12'>
                                                    <span className='title'>Multiple Pregnancy Details</span>
                                                </div>
	                                            <div className='col-12'>
	                                                <table className="table table-bordered mt-3" >
	                                                    <thead>
	                                                        <tr>
	                                                            <td width="5%">FETUS NO.</td>
	                                                            <td width="10%">Delivery Type</td>
	                                                            <td width="10%">Delivery Place</td>
	                                                            <td width="10%">Outcome</td>
	                                                            <td width="5%">Gender</td>
	                                                            <td width="10%">Birth Date & Time</td>
	                                                            <td width="10%">Birth Weight (kg)</td>
	                                                            <td width="10%">Birth Height (cm)</td>
	                                                            <td width="10%">Birth Head CC (cm)</td>
	                                                            <td width="10%">Congenital Abnormality</td>
	                                                            <td width="10%">Congenital Abnormality Remarks</td>
	                                                        </tr>
	                                                    </thead>
	                                                    <tbody>
	                                                        {this.showMultiplePregnancyData(AncCardData?.multiple_pregnancies)}
	                                                    </tbody>
	                                                </table>
	                                            </div>
	                                        </div>
                                        : 
                                        null
                                    }
                                    <div className='row mt-3'>
                                        {
                                        	AncCardData?.delivery_indication_for_c_section != null && AncCardData?.delivery_indication_for_c_section != "" 
                                        	?
	                                            <div className='col-6'>
	                                                <span>Indication for C-Section:</span>
	                                                <b> {AncCardData?.delivery_indication_for_c_section}</b>
	                                            </div>
                                            : 
                                            null
                                        }
                                        {
                                        	AncCardData?.delivery_details != null && AncCardData?.delivery_details != "" 
                                        	?
	                                            <div className='col-6'>
	                                                <span>Details:</span>
	                                                <b> {AncCardData?.delivery_details}</b>
	                                            </div>
                                            : 
                                            null
                                        }
                                    </div>
                                    <div className='row mt-3 '>
                                        <div className='col-12 text-center'>
											<button onClick={() => this.printAncDetails()} type="button" className="btn btn-primary px-5 mr-3">Print {this.state.isPrintLoader ? LOADER : null}</button>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal
                    title="Anc Details"
                    visible={this.state.showRxModal}
                    footer={false}
                    width={850}
                    onCancel={() => { this.setState({ showRxModal: false, rxPdfPath: null }) }}
                    style={{ top: 20 }}
                >
                    <div className="row">
                        <div className="col-12 my-3 text-center">
                            <iframe src={this.state.rxPdfPath} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700"></iframe>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}


